<template>
  <el-form
    status-icon
    :model="driver"
    :rules="rules"
    label-position="top"
    ref="ruleForm"
    label-width="120px"
    v-loading="loading"
    class="carpo-form demo-ruleForm gap-y-6"
  >
    <el-form-item
      :label="$t('WORKING_STATUS')"
      prop="status.id"
      class="mt-5 md:mt-0"
      v-loading="statusLoading"
    >
      <el-select
        :disabled="ruleForm.disabled"
        :placeholder="$t('SELECT_PLACEHOLDER')"
        filterable
        v-model="driver.status.id"
      >
        <template slot="prefix">
          <StatusPrefix :status="driver.status.id" :statusList="statusList" />
        </template>

        <el-option
          v-for="item in statusList"
          :key="item.id"
          :label="$i18n.locale == 'fa' ? item.fa_title : item.en_title"
          :value="item.id"
        >
          <div class="flex items-center">
            <span
              :style="`background-color:${item.color.code}`"
              class="mx-2 w-2 h-2 rounded-full"
            ></span>
            <span>
              {{ $i18n.locale == 'fa' ? item.fa_title : item.en_title }}
            </span>
          </div>
        </el-option>
      </el-select>
    </el-form-item>

    <el-form-item :label="$t('PERSONNEL_CODE')" prop="employee_id">
      <el-input
        :disabled="ruleForm.disabled"
        type="text"
        @input="driver.employee_id = toEnglish(driver.employee_id)"
        v-model="driver.employee_id"
        autocomplete="off"
      ></el-input>
    </el-form-item>
    <el-form-item :label="$t('HOURLY_SALARY')" prop="hourly_salary">
      <el-input-number
        :disabled="ruleForm.disabled"
        v-model="driver.hourly_salary"
        :min="0"
        :step="100000"
      ></el-input-number>
    </el-form-item>

    <el-form-item :label="$t('CONTRACT_DATE')" prop="contract_date">
      <date-picker
        :disabled="ruleForm.disabled"
        color="#151515"
        class="el-input__inner"
        v-model="driver.contract_date"
        view="year"
        format="jYYYY-jMM-jDD"
        clearable
        :locale="$i18n.locale"
      />
    </el-form-item>
    <el-form-item
      :label="$t('TERM_OF_THE_CONTRACT')"
      prop="term_of_the_contract"
    >
      <el-input-number
        :disabled="ruleForm.disabled"
        v-model="driver.term_of_the_contract"
        :min="1"
      ></el-input-number>
    </el-form-item>

    <FormConfirmation
      :loading="submitLoading"
      v-if="!ruleForm.disabled"
      @resetForm="resetForm('ruleForm')"
      @submitForm="submitForm('ruleForm')"
    />
  </el-form>
</template>

<script>
import { gregorianToJalali } from '@/mixins/gregorianToJalali'
import { jalaliToGregorian } from '@/mixins/jalaliToGregorian'
import FormConfirmation from '@/components/elements/formConfirmation.vue'
import { driverStatus } from '@/api/drivers'
import StatusPrefix from '@/components/elements/statusPrefix'
import { getCompany, addCompany, editCompany } from '@/api/drivers'

export default {
  props: ['ruleForm', 'loading'],
  mixins: [gregorianToJalali, jalaliToGregorian],

  data() {
    return {
      statusList: [],
      get_driver: null,
      statusLoading: true,
      submitLoading: false,
      driver: {
        ...this.ruleForm,
        status: {
          id: '',
        },
      },

      rules: {
        employee_id: [
          {
            required: false,
            message: this.$i18n.t('REQUIRED_FIELD', {
              type: this.$i18n.t('PERSONNEL_CODE'),
            }),
            trigger: 'blur',
          },
        ],

        status: {
          id: [
            {
              required: false,
              message: this.$i18n.t('REQUIRED_FIELD', {
                type: this.$i18n.t('WORKING_STATUS'),
              }),
              trigger: 'blur',
            },
          ],
        },
      },
    }
  },
  methods: {
    submitForm(form) {
      this.$refs[form].validate((valid) => {
        if (valid) {
          const actionPayload = {
            status: this.driver.status.id,
            employee_id: this.driver.employee_id,
            hourly_salary: this.driver.hourly_salary,
            contract_date:
              this.driver.contract_date != ''
                ? this.jalaliToGregorian(
                    this.driver.contract_date,
                    this.$i18n.locale
                  )
                : null,
            term_of_the_contract: this.driver.term_of_the_contract,
            driver: this.ruleForm.id,
            id: this.ruleForm.id,
          }
          this.submitLoading = true
          var dispatchFunc = this.get_driver == null ? addCompany : editCompany

          dispatchFunc.api(actionPayload).then((res) => {
            this.submitLoading = false
            if (res) {
              this.get_driver = res
              this.$notify.success({
                title:
                  this.$t('COMPANY_INFO') + ' ' + this.$t('SUCCESSFULLY_DONE'),
                duration: 5000,
                customClass: 'succ_msg',
              })
            }
          })
        } else {
          this.$notify.error({
            title: this.$i18n.t('FIXED_ERRORS', {
              type: this.$i18n.t('COMPANY_INFO'),
            }),
            duration: 5000,
            customClass: 'error_msg',
          })
          return false
        }
      })
    },
  },
  mounted() {
    driverStatus.api().then((res) => {
      if (res) {
        this.statusList = res
        this.statusLoading = false
      }
    })

    getCompany.api(this.ruleForm.id).then((res) => {
      this.loading = false

      if (res) {
        res = {
          ...res,
          contract_date: this.gregorianToJalali(res.contract_date),
        }
        this.driver = res
        this.get_driver = res
        if (this.driver.status === null) {
          this.driver.status = {
            id: '',
          }
        }
      }
    })
  },
  components: {
    FormConfirmation,
    StatusPrefix,
  },
}
</script>
